import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "15",
  viewBox: "0 0 20 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M20 7.5H0",
    stroke: "black",
    "stroke-width": "1.25"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M20 1.5H0",
    stroke: "black",
    "stroke-width": "1.25"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M20 13.5H0",
    stroke: "black",
    "stroke-width": "1.25"
  })
], -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "hamburger-menu__drawer" }
const _hoisted_4 = { class: "hamburger-menu__main-links-container" }
const _hoisted_5 = { class: "hamburger-menu__main-links" }
const _hoisted_6 = { class: "hamburger-menu__main-links" }
const _hoisted_7 = { class: "hamburger-menu__country-switcher" }
const _hoisted_8 = { class: "clean-button" }

import {
  ref, watch, inject, computed, ComputedRef,
} from 'vue';
import useContext from '@/composables/useContext';
import DrawerLayer from '../DrawerLayer.vue';
import CountrySwitcher from '../CountrySwitcher.vue';
import HamburgerMenuMain from './HamburgerMenuMain.vue';

interface MenuContent {
  type: string;
  id: string;
  url: string;
  label: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HamburgerMenu',
  setup(__props) {

const headerState = inject('headerState', { theme: '', scrolled: false });
const invertColor = computed(() => (headerState.theme === 'white' && !headerState.scrolled ? 1 : 0));

const { route } = useContext();

const isOpen = ref(false);
const menuContent = inject('$mainMenuReactive') as ComputedRef<MenuContent[]>;

const menuMains = computed(() => {
  return menuContent.value.filter(m => m.type === 'MenuMain');
});

const menuLinks = computed(() => {
  return menuContent.value.filter(m => m.type === 'MenuItem');
});

watch(() => route?.pathname, close);

function close() {
  isOpen.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps(_ctx.$attrs, {
      class: ['hamburger-menu__action', `hamburger-menu__action--inverted-${_unref(invertColor)}`],
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = true))
    }), _hoisted_2, 16),
    _createVNode(DrawerLayer, {
      showCloseIcon: false,
      modelValue: isOpen.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isOpen).value = $event)),
      key: "hamburger-menu"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: close,
            class: "hamburger-menu__drawer-close clean-button"
          }, " × "),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("ul", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuMains), (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "hamburger-menu__main-item",
                  key: item.id
                }, [
                  _createVNode(HamburgerMenuMain, { menuItem: item }, null, 8, ["menuItem"])
                ]))
              }), 128))
            ]),
            _createElementVNode("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuLinks), (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "hamburger-menu__link-item",
                  key: item.id
                }, [
                  _createVNode(_component_router_link, {
                    to: item.url,
                    onClick: close,
                    class: "hamburger-menu__main-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", _hoisted_8, [
              _createVNode(CountrySwitcher)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})